var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4502 3.93288L10.8668 2.21621C10.3918 2.04121 9.61683 2.04121 9.14183 2.21621L4.5585 3.93288C3.67516 4.26621 2.9585 5.29954 2.9585 6.24121V12.9912C2.9585 13.6662 3.40016 14.5579 3.94183 14.9579L8.52516 18.3829C9.3335 18.9912 10.6585 18.9912 11.4668 18.3829L16.0502 14.9579C16.5918 14.5495 17.0335 13.6662 17.0335 12.9912V6.24121C17.0418 5.29954 16.3252 4.26621 15.4502 3.93288ZM12.9002 8.59954L9.31683 12.1829C9.19183 12.3079 9.0335 12.3662 8.87516 12.3662C8.71683 12.3662 8.5585 12.3079 8.4335 12.1829L7.10016 10.8329C6.8585 10.5912 6.8585 10.1912 7.10016 9.94954C7.34183 9.70788 7.74183 9.70788 7.9835 9.94954L8.8835 10.8495L12.0252 7.70788C12.2668 7.46621 12.6668 7.46621 12.9085 7.70788C13.1502 7.94954 13.1502 8.35788 12.9002 8.59954Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shield-tick.0dd36d2c575c1883baeddd897da15d07.svg";
export { ForwardRef as ReactComponent };